import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from "react";
import classNames from "classnames";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import IconButton from "@material-ui/core/IconButton";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { makeStyles } from "@material-ui/styles";
import withStyles from "@material-ui/core/styles/withStyles";
var variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};
var actionsStyles = makeStyles(function (theme) {
  return {
    success: {
      backgroundColor: green[600]
    },
    error: {
      backgroundColor: theme.palette.error.dark
    },
    info: {
      backgroundColor: theme.palette.primary.dark
    },
    warning: {
      backgroundColor: amber[700]
    },
    icon: {
      fontSize: 20
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit
    },
    message: {
      display: "flex",
      alignItems: "center"
    }
  };
});

var MySnackbarContent = /*#__PURE__*/function (_React$Component) {
  _inherits(MySnackbarContent, _React$Component);

  var _super = _createSuper(MySnackbarContent);

  function MySnackbarContent() {
    _classCallCheck(this, MySnackbarContent);

    return _super.apply(this, arguments);
  }

  _createClass(MySnackbarContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          message = _this$props.message,
          onClose = _this$props.onClose,
          variant = _this$props.variant,
          other = _objectWithoutProperties(_this$props, ["classes", "className", "message", "onClose", "variant"]);

      var Icon = variantIcon[variant];
      return /*#__PURE__*/React.createElement(SnackbarContent, Object.assign({
        className: classNames(classes[variant], className),
        "aria-describedby": "client-snackbar",
        message: /*#__PURE__*/React.createElement("span", {
          id: "client-snackbar",
          className: classes.message
        }, /*#__PURE__*/React.createElement(Icon, {
          className: classNames(classes.icon, classes.iconVariant)
        }), message),
        action: [/*#__PURE__*/React.createElement(IconButton, {
          key: "close",
          "aria-label": "Close",
          color: "inherit",
          className: classes.close,
          onClick: onClose
        }, /*#__PURE__*/React.createElement(CloseIcon, {
          className: classes.icon
        }))]
      }, other));
    }
  }]);

  return MySnackbarContent;
}(React.Component);

var SnackbarContentHelper = withStyles(actionsStyles, {
  withTheme: true
})(MySnackbarContent);
export default SnackbarContentHelper;